module.exports = __webpack_public_path__ + "746b5d05748bfe4cac7f9efb985a8dd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/duke_university_2021_chart.png
// module id = 1670
// module chunks = 0